module.exports = __webpack_public_path__ + "img/loupe.b5a8d1cc.svg";